<template>
  <div>
    <b-form-checkbox v-model="item" :value="1" :unchecked-value="0" @change="onChangeCheckbox" />
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    onChangeCheckbox($ev) {
      this.$emit("changedCheckbox", $ev);
    },
  },
};
</script>
